import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

type Props = { children: ReactNode };

export const BETA_MODE = import.meta.env.VITE_BETA_MODE === 'true';

export const isAllowedInBeta = (pathname: string): boolean =>
  pathname === '/dashboard' ||
  pathname === '/panel' ||
  pathname === '/admin' ||
  pathname === '/communities' ||
  pathname.startsWith('/c/') ||
  pathname === '/associations' ||
  pathname.startsWith('/a/') ||
  pathname === '/account' ||
  pathname === '/account/edit' ||
  pathname === '/account/documents' ||
  pathname === '/report' ||
  pathname === '/diary' ||
  pathname === '/meds' ||
  pathname === '/feed' ||
  pathname === '/messages' ||
  pathname === '/notifications' ||
  pathname === '/reels' ||
  pathname === '/explore' ||
  pathname.startsWith('/marketplace') ||
  pathname === '/donations' ||
  pathname === '/search' ||
  pathname === '/strains/compare' ||
  pathname === '/manage/reviews' ||
  pathname === '/manage/docs' ||
  pathname === '/manage/team' ||
  pathname === '/manage/sales' ||
  pathname === '/claim' ||
  pathname === '/admin/complaints' ||
  pathname === '/admin/waitlist';

export const isBetaNavigationRoute = (pathname: string): boolean =>
  isAllowedInBeta(pathname) ||
  pathname === '/strains' ||
  pathname === '/effects' ||
  pathname === '/legal';

export const isBetaRouteAllowedForRole = (pathname: string, role: string): boolean => {
  if (pathname === '/panel' || pathname === '/manage/reviews' || pathname === '/manage/docs' || pathname === '/manage/team' || pathname === '/manage/sales' || pathname === '/claim') return role === 'assoc';
  if (pathname === '/admin' || pathname === '/admin/waitlist' || pathname === '/admin/complaints') return role === 'admin';
  return isBetaNavigationRoute(pathname);
};

export const BetaRouteGate = ({ children }: Props) => {
  const { pathname } = useLocation();

  if (BETA_MODE && !isAllowedInBeta(pathname)) {
    return <Navigate to="/associations" replace />;
  }

  return <>{children}</>;
};
